import React from 'react'
import Swal from 'sweetalert2'
import { MutationDeleteAdminEmpresaUsuario } from '../../../../../graphql/services/Empresas';
import { MutationSetLogAcessoRecurso } from '../../../../../graphql/services/LogAcesso';
import { EditEmpresaUsuario } from './EditUser';
import { KTSVG } from '../../../../../../_metronic/helpers';
import { errorHandler } from '../../../../../graphql/errorHandler';

type Props = {
  idUsuario: any
  idAssociacao: number;
}

export const Buttons: React.FC<Props> = ({idUsuario, idAssociacao}) => {
  const { HandleDeleteAdminEmpresaUsuario, loading } = MutationDeleteAdminEmpresaUsuario()
  const { FormSetLogAcessoRecurso } = MutationSetLogAcessoRecurso()

  function confirmDelete(id: number) {
    Swal.fire({
      title: 'Tem certeza que deseja excluir?',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Excluir',
      showCloseButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const result = await HandleDeleteAdminEmpresaUsuario({ variables: { deleteEmpresaUsuarioAdminId: idAssociacao } })
        if (result.data) {
          FormSetLogAcessoRecurso({ ferramenta: 'Perfil', funcionalidade: 'Funcionario', action: 'delete', url: '/profile#funcionarios' });
          Swal.fire('Sucesso!', 'Usuario deletado com sucesso.', 'success')
        } else {
          let erro = errorHandler(result.errors)
          Swal.fire('', erro, 'warning')
        }
      }
    })
  }

  return (
    <>
      <div className='d-flex justify-content-end flex-shrink-0'>
        <EditEmpresaUsuario id_usuario={idAssociacao} />
        <button
          onClick={(e) => {
            confirmDelete(idUsuario)
          }}
          disabled={loading}
          className='btn btn-icon btn-light-danger btn-sm' >
          <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
        </button>
      </div>
    </>
  )
}
